import type { ReactNode } from 'react'
import cn from 'classnames'
import styles from './ContentSection.module.css'

interface ContentSectionProps {
  children?: ReactNode
  className?: string
}

export function ContentSection({ children, className }: ContentSectionProps) {
  return <section className={cn(styles.contentSection, className)}>{children}</section>
}
